import { DetailsEditor, Divider, GoBack } from "uikit"
import React from "react"
import { Route, Switch, withRouter, Redirect } from "react-router-dom"
import { Button, Grid, Icon } from "semantic-ui-react"
import { useStore } from "store"
import { CardGroup } from "./CardGroup"
import EmployerWorksheet from "./worksheets/EmployerWorksheet"
import HouseholdProfileWorksheet from "./worksheets/HouseholdProfileWorksheet"
import PersonWorksheet from "./worksheets/PersonWorksheet"
import FaqLinks from "components/FaqLinks"

const UserIcon = () => (
  <div style={{ paddingTop: "1.5em" }}>
    <Icon name="users" size="huge" />
  </div>
)

const HouseholdProfileWorksheetView = ({
  household,
  baseUrl,
  success,
  onDone
}) => {
  const [people] = useStore("householdPeople", household.id)
  const [employers] = useStore("householdEmployers", household.id)
  const isClientAvailable = Object.values(people).find(
    person => person.role === "client"
  )
  const isSpouseAvailable = Object.values(people).find(
    person => person.role === "spouse"
  )

  const [{ label, description, faqs }] = useStore(
    "contextuals",
    `Screen: profile`
  )

  return (
    <Grid className="white">
      <Grid.Row>
        <Grid.Column>
          <DetailsEditor
            iconImage={UserIcon}
            heading={label}
            description={description}
            supplement={<FaqLinks items={faqs} />}
          >
            <Grid textAlign="center">
              <CardGroup
                items={[household]}
                cardType="Household"
                baseUrl={baseUrl}
                itemsPerRow={1}
              />
              <Divider label="CLIENTS" />
              <CardGroup
                items={Object.values(people).filter(
                  person => person.role === "client" || person.role === "spouse"
                )}
                cardType="Client"
                addCardLabel={
                  isClientAvailable && isSpouseAvailable
                    ? ""
                    : `Add ${isClientAvailable ? "Spouse" : "Client"}`
                }
                addCardLink={`/household-profile/person/new/${
                  isClientAvailable ? "spouse" : "client"
                }`}
                baseUrl={baseUrl}
              />
              <Divider label="CHILDREN" />
              <CardGroup
                items={Object.values(people).filter(
                  person => person.role === "child"
                )}
                cardType="Child"
                addCardLabel="Add Child"
                addCardLink="/household-profile/person/new/child"
                baseUrl={baseUrl}
              />
              <Divider label="EMPLOYERS" />
              <CardGroup
                items={Object.values(employers)}
                cardType="Employer"
                baseUrl={baseUrl}
              />
            </Grid>
          </DetailsEditor>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ borderTop: "1px solid #ccc" }}>
        <Grid.Column textAlign="right" style={{ paddingRight: "2em" }}>
          <Button
            content="Done"
            onClick={() => onDone()}
            primary
            type="button"
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

const HouseholdProfile = withRouter(
  ({ match: { url: baseUrl }, history, household }) => {
    return (
      <Switch>
        <Route
          path={baseUrl}
          exact
          render={() => (
            <HouseholdProfileWorksheetView
              household={household}
              baseUrl={baseUrl}
              success={<GoBack />}
              onDone={() => history.goBack()}
            />
          )}
        />

        <Route
          path={`${baseUrl}/household`}
          render={() => (
            <HouseholdProfileWorksheet
              household={household}
              onCancel={() => history.goBack()}
              success={<GoBack />}
              baseUrl={baseUrl}
            />
          )}
        />
        <Route
          path={`${baseUrl}/person/:id/:role?`}
          render={({
            match: {
              params: { id, role }
            }
          }) => {
            const isNew = id === "new"
            if (isNew) {
              return (
                <PersonWorksheet
                  household={household}
                  newPerson={null}
                  role={role}
                  onCancel={() => history.goBack()}
                  success={<GoBack />}
                  baseUrl={baseUrl}
                />
              )
            }
            return (
              <PersonWorksheet
                household={household}
                personId={id}
                role={role}
                onCancel={() => history.goBack()}
                success={<GoBack />}
                baseUrl={baseUrl}
              />
            )
          }}
        />
        <Route
          path={`${baseUrl}/employer/:id`}
          render={({
            match: {
              params: { id }
            }
          }) => {
            return (
              <EmployerWorksheet
                employerId={id}
                household={household}
                onCancel={() => history.goBack()}
                success={<GoBack />}
                baseUrl={baseUrl}
              />
            )
          }}
        />
        <Redirect to={`${baseUrl}`} />
      </Switch>
    )
  }
)

export default HouseholdProfile
